export default __webpack_public_path__ + "static/media/Group9160.393ec8af.svg";